// extracted by mini-css-extract-plugin
export default {"root":"root__acxIH","plot":"plot__0t6Ft"};